import axios from "axios"; // Import Axios

export default async function FetchData(
	csvUrl,
	callback = function () {},
	errorCallback = function () {}
) {
	// const [csvData, setCsvData] = useState([]);
	// console.log("csvURL: " + csvUrl);

	axios
		.get(csvUrl)
		.then((response) => {
			const cartaArray = [];

			const platos = response.data.values;

			for (var i = 1; i < platos.length; i++) {
				// we start at i = 1 cause i = 0 are headers

				var row = {}; // Create a new row object for each row
				for (var j = 0; j < 100; j++) {
					if (platos[i][j] === undefined) {
						break;
					}
					row[platos[0][j]] = platos[i][j];
				}
				cartaArray.push(row); // Push the row object to the output array
			}

			callback(cartaArray);
		})
		.catch((error) => {
			errorCallback(error);
			console.error("Error fetching CSV data:", error);
		});

	return;
}
